<template>
    <div class="main">
        <div class="menu">
            <p><a @click="toggleUpload"><i class="fas fa-image"></i></a></p>
            <!-- adds a click method for the upload icon, which toggles a show property that causes the Uploader component to show itself -->
            <h2>{{user.firstName}} {{user.lastName}} <a @click="logout"><i class="fas fa-sign-out-alt"></i></a></h2>
            <!-- pass data to the Uploader, the MyPage view binds show to a local variable (gets passes as show property in the componenet
            To setup events that the child component -- Uploader -- can call on the parent view -- MyPhotos,
            we bind several event handlers. These match the emitted events in the child component.-->
            <uploader :show="show" @close="close" @uploadFinished="uploadFinished" />
        </div>
        <image-gallery :photos="photos" /> <!--includes image gallery component, passing it an array of photos for its props-->
        <p v-if="error">{{error}}</p>
    </div>
</template>

<script>
    import axios from 'axios';
    import Uploader from '@/components/Uploader.vue';
    import ImageGallery from '@/components/ImageGallery.vue';
    export default {
        name: 'MyPhotos',
        components: {
            Uploader,
            ImageGallery
        },
        data() {
            return {
                show: false,
                photos: [],
                error: '',
            }
        },
        computed: { //provides access to the current user's record
            user() {
                return this.$root.$data.user;
            },
        },
        created() { //gets an array of photos when this page is loaded
            this.getPhotos();
        },
        methods: {
            async logout() { //uses the DELETE /api/users endpoint to logout the user
                try {
                    await axios.delete("/api/users");
                    this.$root.$data.user = null;
                } catch (error) {
                    this.$root.$data.user = null;
                }
            },
            async getPhotos() {
                try {
                    this.response = await axios.get("/api/photos");
                    this.photos = this.response.data;
                } catch (error) {
                    this.error = error.response.data.message;
                }
            },
            //toggles the uploader
            close() {
                this.show = false;
            },
            toggleUpload() {
                this.show = true;
            },
            async uploadFinished() { //handles the event that occurs when the uploader finishes
                this.show = false;
                this.getPhotos();
            },
        }
    }
</script>

<style scoped>
    .menu {
        display: flex;
        justify-content: space-between;
    }

    .menu h2 {
        font-size: 14px;
    }
</style>